import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'

import { addToast } from 'components/Toast/Toast'
import { getTwitterLoginLink } from 'services/endpoints/auth'

export const useTwitterLogin = () => {
    const { t } = useTranslation()

    return useMutation(async () => {
        const nonce = crypto.randomUUID()

        sessionStorage.setItem('twitter_login_nonce', nonce)
        sessionStorage.setItem('twitter_login_started_at', String(Date.now()))

        return await getTwitterLoginLink(nonce)
    }, {
        onSuccess: response => {
            const link = response?.data?.message?.target_url

            if (link) {
                window.location.href = link
            }
        },
        onError: () => {
            sessionStorage.removeItem('twitter_login_nonce')
            sessionStorage.removeItem('twitter_login_started_at')

            addToast('error', t('error:errorSomethingWentWrong'))
        }
    })
}